/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * What a storage transaction does to the stock of its storage location, material and AVV.
 */
export enum EnumStorageTransactionType {
    /**
     * Material comes into the storage location and raises the stock by the quantity.
     */
    Incoming = 1,
    /**
     * Material leaves the storage location and lowers the stock by the quantity.
     */
    Outgoing = 2,
    /**
     * A stocktaking: sets the stock to the counted quantity, whatever it was before.
     */
    Stocktaking = 3,
}
